import React, { useState, useEffect } from "react";
import axios from 'axios'
// Chakra imports
import {
    Box,
    Flex,
    Button,
    FormControl,
    FormLabel,
    HStack,
    Input,
    Icon,
    Link,
    Switch,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";

import {useLocation, Redirect} from "react-router-dom";

import apiUrl from 'variables/api'

//Components
import DiscordButton from "components/Buttons/Discord";

function SignIn() {


    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const hash = window.location.hash;
    const token = hash.split('=')[1];
    if(token) {
        console.log(token)
        localStorage.setItem('token', token)
        return <Redirect to='/swd/homepage'/>
    }


    // useEffect(() => {
    //   /*
    //   axios.get(`http://localhost:3001/callback?code=${code}`)
    //   .then(response => {
    //     console.log(response.data)
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
    //   /*
    //   localStorage.setItem('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiNjQzMDE0Nzg2YjdiNGIwOTI3NTQ4ZTkwIiwiZW1haWwiOiIxMjNAZ21haWwuY29tIiwiaWF0IjoxNjgwODcyODc2LCJleHAiOjE2ODA4ODAwNzZ9.6dFhQ02BBbL1Ov9B3iVBE132OG2yHl510xGGgr-R0B4')
    //   axios.get('http://localhost:4001/welcome', {
    //     headers: { 'x-access-token': localStorage.getItem('token') }
    //   })
    //     .then(response => {
    //       console.log(response.data)
    //     })
    //     .catch(error => {
    //       console.error(error);
    //     });
    //     */
    //   // const intervalId = setInterval(() => {
    //   //   axios.get('http://localhost:3001/private/islogged')
    //   //     .then(response => {
    //   //       setIsLoggedIn(response.data.logged);
    //   //     })
    //   //     .catch(error => {
    //   //       console.error(error);
    //   //     });
    //   // }, 60000);

    //   // return () => clearInterval(intervalId);
    // }, []);

    // Chakra color mode
    const textColor = useColorModeValue("gray.700", "white");
    const bgForm = useColorModeValue("white", "gray.600");
    return (
        <Flex position='relative' mb='40px'>
            <Flex
                h={{ sm: "initial", md: "75vh", lg: "85vh" }}
                w='100%'
                maxW='1044px'
                mx='auto'
                justifyContent='space-between'
                mb='30px'
                pt={{ md: "0px" }}>
                <Flex
                    w='100%'
                    h='100%'
                    alignItems='center'
                    justifyContent='center'
                    mb='60px'
                    mt={{ base: "50px", md: "20px" }}>
                    <Flex
                        zIndex='2'
                        direction='column'
                        w='445px'
                        background='transparent'
                        borderRadius='15px'
                        p='40px'
                        mx={{ base: "100px" }}
                        m={{ base: "20px", md: "auto" }}
                        bg={bgForm}
                        boxShadow={useColorModeValue(
                            "0px 5px 14px rgba(0, 0, 0, 0.05)",
                            "unset"
                        )}>
                        <Text
                            fontSize='xl'
                            color={textColor}
                            fontWeight='bold'
                            textAlign='center'
                            mb='22px'>
                            Zaloguj, aby kontynuować
                            {name}
                        </Text>
                        <HStack spacing='15px' justify='center' mb='22px'>
                            <DiscordButton text="Zaloguj się za pomocą discord'a" url={apiUrl + '/auth/login'} />
                        </HStack>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
}

export default SignIn;
